import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '@store/states/auth.state';

const authSelector = createFeatureSelector<AuthState>('auth');
export const authSelectors = {
  idp: createSelector(authSelector, (state) => state.idp),
  checking: createSelector(authSelector, (state) => state.checkingAuth),
};
